import Vue from "vue";
import Router from "vue-router";
import store from "@/vuex/store.js";
import { isSupportedBrowser } from "@/util";
import UnsupportedBrowserPage from "@/components/misc/UnsupportedBrowserPage";
import NotFoundPage from "@/components/misc/NotFoundPage";
import TodoPage from "@/components/misc/TodoPage";
import StorefrontContainer from "@/modules/shop/StorefrontContainer.vue";
import CheckoutPage from "@/modules/shop/CheckoutPage.vue";
import LoginRegisterPage from "@/modules/auth/LoginRegisterPage.vue";
import ShopView from "@/modules/shop/ShopView.vue";
/**
 * Auth setup:
 *
 * Before we init the router, we check for an auth cookie & add this to vuex
 * This allows us skip login if the user has saved credentials
 *
 */

store.dispatch("setupUserAuthFromCookie");
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/store/:id",
      component: StorefrontContainer,
      meta: {
        auth: false,
        checkBrowserIsSupported: true
      },
      children: [
        {
          // /store/:id
          // default child route for a store, showing products
          path: "",
          name: "storefront",
          component: ShopView,
          meta: {
            auth: false,
            showCartIcon: true
          }
        },
        {
          // /store/:id/checkout
          path: "checkout",
          name: "checkout",
          component: CheckoutPage,
          meta: {
            auth: true,
            showCartIcon: false
          }
        },
        {
          path: "signin",
          name: "signin",
          component: LoginRegisterPage,
          meta: {
            auth: false,
            showCartIcon: true
          }
        }
      ]
    },
    {
      path: "/unsupported",
      name: "unsupportedBrowserPage",
      component: UnsupportedBrowserPage,
      meta: {
        auth: false
      }
    },
    {
      path: "/404",
      name: "404",
      component: NotFoundPage,
      meta: {
        auth: false
      }
    },
    {
      path: "/todo",
      name: "todo",
      component: TodoPage,
      meta: {
        auth: false
      }
    }
  ],
  mode: "history"
});

const browserSupported = isSupportedBrowser();

router.beforeEach((to, from, next) => {
  // handle 404s
  if (!to.matched.length || to.fullPath === "/") {
    console.log(`[Router] Route not found: ${to.fullPath}`);
    console.log(to);
    next({
      path: "/404"
    });
  } else {
    console.log("[Router] Navigate to " + to.matched.slice(-1)[0].path);
    // otherwise we have a valid route

    // if the route requires one of supported browsers, ensure the user has one
    if (
      to.matched.some(record => record.meta.checkBrowserIsSupported === true)
    ) {
      if (!browserSupported) {
        console.log(
          "[Router] Route requires a browser the user does not support"
        );
        next({
          path: "/unsupported"
        });
        return;
      }
    }
    // before navigating, check if the route requires auth
    // if not logged in, we'll redirect the user to the login page
    if (to.matched.some(record => record.meta.auth === true)) {
      if (store.getters.userIsLoggedIn === false) {
        console.log(`[Router] User is not logged in`);
        let nextParams = {
          name: "signin"
        };
        // if the user is trying to access a named path (e.g. /schools)
        // we'll include this as a redirect so they're
        // taken there after login
        if (to.fullPath !== "/") {
          nextParams.query = {
            redirect: to.fullPath
          };
        }
        next(nextParams);
      } else {
        console.log(`[Router] User is logged in`);
        next();
      }
    } else {
      console.log(`[Router] Route doesn't require auth`);
      next();
    }
  }
});

export default router;
